import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { IntegracaoService } from "src/app/features/integracao/integracao.service";
import { TipoIpoc } from "src/app/features/integracao/scr-ipoc/ipoc-cadastro.component";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { OperacaoScr } from "src/app/model/operacao-scr.model";
import { VerticeOperacaoScr } from "src/app/model/vertice-operacao-scr.model";

@Component({
   selector: 'aba-operacao-scr',
    templateUrl: 'aba-operacao-scr.component.html',
    standalone: false
})
export class AbaOperacaoScrComponent implements OnChanges {
    @Input()
    public model:OperacaoGarantida;
    operacaoScr: OperacaoScr[];
    operacaoScrCooperativa: OperacaoScr[];
    showMessage:boolean = false;
    showMessageCoop:boolean = false;
    vertices:VerticeOperacaoScr[];
    @Input() panelId= "ngb-panel-0";

    constructor(
        private integracaoService:IntegracaoService
    ){
    }

    ngOnChanges(changes: SimpleChanges): void {

        const params: any = {};
        params.codigoTipoIpoc = TipoIpoc.CONVENCIONAL;
        this.model.codigoTipoOperacao
        
        this.integracaoService.getOperacoesScrs(this.model.id,params).subscribe(resp =>{
            this.operacaoScr = resp;
            this.showMessage = !resp;
            console.log(resp)

        });

        params.codigoTipoIpoc = TipoIpoc.COOPERATIVA;
        this.integracaoService.getOperacoesScrs(this.model.id,params).subscribe(resp =>{
            this.operacaoScrCooperativa = resp;
            this.showMessageCoop = !resp;
            this.panelId= !resp ? "panelConvencional": "ngb-panel-0";
            console.log(resp)
        });

    }

    tratarVertice(vertices:VerticeOperacaoScr[]):VerticeOperacaoScr[] | string {
        const detalhe = new Array<DetalheVertice>();

        if(vertices){
            vertices.filter(ver=>{
                let v = new DetalheVertice();
                v.valor = 0;
                v.descricao = ver.tipoVertice.toUpperCase() + (ver.prazoMaximoInclusive ? " ATE "+ ver.prazoMaximoInclusive : " ACIMA DE 360 ")  + " DIAS ";

               vertices.forEach(e=>{
                if(!!ver.prazoMinimoInclusive && ver.prazoMinimoInclusive>=e.prazoMinimoInclusive && e.tipoVertice == ver.tipoVertice){
                    v.valor += Number(ver.valorVertice||0);
                }
               })
               detalhe.push(v);
            })
            console.log(detalhe);
            return;
        }
        return "Nao ha vertices nesta operacao";
    }

    formataTipoVerticeScr(vertice: VerticeOperacaoScr): string {
      if (!vertice.prazoMinimoInclusive && !vertice.prazoMaximoInclusive) {
        return vertice.tipoVertice.toUpperCase() + " COM PRAZOS INDETERMINADOS";
      } else if (!vertice.prazoMaximoInclusive) {
        return vertice.tipoVertice.toUpperCase() + " ACIMA DE " + (Number(vertice.prazoMinimoInclusive) - 1);
      }
      return vertice.tipoVertice.toUpperCase() + " ENTRE " + vertice.prazoMinimoInclusive + " E " + vertice.prazoMaximoInclusive + " DIAS";
    }

}

class DetalheVertice {
    descricao;
    valor;
}
